import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core'
import { MbSubmitOrderBase } from '../mb-submit-order-base'
import {
  MbSubmitOrderTermConditionComponent
} from '../mb-submit-order-term-condition/mb-submit-order-term-condition.component'
import { MbOrderService } from '../../../../checkout/services/mb-order.service'
import { CartCheckoutService } from '../../../services/mb-cart-checkout.service'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Component({
  selector: 'mb-submit-order-review',
  templateUrl: './mb-submit-order-review.component.html',
  styleUrls: ['../mb-submit-order-base.scss']
})
export class MbSubmitOrderReviewComponent extends MbSubmitOrderBase {

  @ViewChild(MbSubmitOrderTermConditionComponent)
  private mbSubmitOrderTermConditionComponent: MbSubmitOrderTermConditionComponent | undefined

  constructor (protected activeCartService: ActiveCartService,
               protected mbCheckoutService: MbOrderService,
               protected elem: ElementRef,
               protected renderer: Renderer2,
               protected cartCheckoutService: CartCheckoutService) {
    super(activeCartService, elem, renderer, cartCheckoutService)
  }

  onPlaceOrderClick () {
    if (this.mbSubmitOrderTermConditionComponent?.isTypeACheckout) {
      if (!this.mbSubmitOrderTermConditionComponent?.termsOfUseForm.valid &&
        !this.mbSubmitOrderTermConditionComponent?.termsConditionsForm.valid) {
        this.mbSubmitOrderTermConditionComponent.termsOfUseForm.markAllAsTouched()
        this.mbSubmitOrderTermConditionComponent?.termsConditionsForm.markAllAsTouched()
      } else if (!this.mbSubmitOrderTermConditionComponent?.termsOfUseForm.valid) {
        this.mbSubmitOrderTermConditionComponent.termsOfUseForm.markAllAsTouched()
      } else if (!this.mbSubmitOrderTermConditionComponent?.termsConditionsForm.valid) {
        this.mbSubmitOrderTermConditionComponent?.termsConditionsForm.markAllAsTouched()
      } else {
        this.mbCheckoutService.triggerPlaceOrder()
      }
    } else {
      if (this.mbSubmitOrderTermConditionComponent?.termsConditionsForm.valid) {
        this.mbCheckoutService.triggerPlaceOrder()
      } else {
        this.mbSubmitOrderTermConditionComponent?.termsConditionsForm.markAllAsTouched()
      }
    }
  }
}
